import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import apiBaseUrl from '@/api/base-url';

export default function getNotificationHub(authToken: string): HubConnection {
    return new HubConnectionBuilder()
        .withUrl(`${apiBaseUrl}hubs/notification`, { accessTokenFactory: () => authToken })
        .withAutomaticReconnect()
        .build();
}
